import { createStore, combineReducers } from "redux";
import sessionReducer from "./sessionSlice";

const rootReducer = combineReducers({
  session: sessionReducer,
});

export const store = createStore(rootReducer);
